import { TableV3Filters } from 'common/table/components/TableV3';
import { SearchableCandidateFilterInput } from 'generated-graphql/types';
import { CandidatesTableColumns } from '../tables/types/CandidatesTable';
import {
  buildSearchableCandidateFilters,
  buildFullNameFilter,
  buildAtsApplicationSourceFilter,
  buildStatusFilter,
  buildOriginFilter
} from './buildSearchableCandidateFilters';

type GetCandidatesFiltersProps = {
  candidateBatchId: string;
  filters: TableV3Filters<CandidatesTableColumns>;
};

export const getCandidatesFilters = ({
  candidateBatchId,
  filters
}: GetCandidatesFiltersProps): SearchableCandidateFilterInput => {
  return buildSearchableCandidateFilters<keyof CandidatesTableColumns>({
    searchFields: filters.searchFields,
    filterValues: filters.filterValues,
    searchFieldHandlers: {
      applicantName: buildFullNameFilter,
      atsApplicationSource: buildAtsApplicationSourceFilter
    },
    filterValueHandlers: {
      status: buildStatusFilter,
      isLocked: (items, andConditions) => {
        andConditions.push({
          isLocked: { eq: items[0].value === 'true' }
        });
      },
      origin: buildOriginFilter
    },
    baseFilter: { candidateBatchId: { eq: candidateBatchId } },
    shouldTrimSearchFields: true
  });
};
